import * as Effects from 'redux-saga/effects'
import { all, call, put, take } from 'redux-saga/effects'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'
import fetchActionsName, { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import { IntegrationStatus } from '../../reducers/airbnb'
import { makeBoxBuyStatusIntegration } from '../../models/Integration/makeBoxBuyIntegration'

function* getBoxBuyIntegration() {
  try {
    yield put({ type: IntegrationAction.SetBoxBuyLoading, payload: true })
    const actionNames = fetchActionsName(ActionNames.FetchBoxBuyIntegration)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(
        callFetch(
          actionNames.input,
          actionNames.output,
          makeBoxBuyStatusIntegration,
        ),
      ),
    ])

    const result = yield call(service)
    if (result?.items?.status === '1') {
      yield Effects.put({
        type: IntegrationAction.SetBoxBuyIntegration,
        payload: IntegrationStatus.Integrated,
      })
    }

  } catch (e) {
    yield Effects.put({
      type: IntegrationAction.SetBoxBuyIntegration,
      payload: IntegrationStatus.NotIntegrated,
    })
  } finally {
    yield put({ type: IntegrationAction.SetBoxBuyLoading, payload: false })
  }
}

export default function*() {
  yield call(getBoxBuyIntegration)
  yield Effects.takeLatest(
    IntegrationAction.GET_BOXBUY_STATUS,
    getBoxBuyIntegration,
  )
}
